import type { FC } from "react";
import type { IDashboardWidgetInterface } from "app/components/widget/utils/DashboardWidgetsInterfaces-v2";
import { i18nFilter } from "app/filters/i18nFilter";
import styled from "styled-components";
import { CenteredFlexColumn, CenteredFlexRow } from "pro-features/styled components/StyledFlex/src/StyledFlex";
import { colorsPalettes, setFontVariant } from "@similarweb/styles";
import { dynamicFilterFilter } from "app/filters/dynamicFilter";

const ShareCellWrapper = styled(CenteredFlexRow)`
    font-size: 16px;
`;

const Share = styled.span`
    margin-right: 5px;
    ${setFontVariant("subTitle3")}
`;

const Visits = styled.div`
    font-size: 50px;
    margin-bottom: 24px;
`;

const TotalVisitsWithShareWrapper = styled(CenteredFlexColumn)`
    color: ${colorsPalettes.midnight[400]};
    height: 100%;
`;

export const SingleMetricTotalVisitsWithShareTemplateV2: FC<IDashboardWidgetInterface> = (props) => {
    const { widget, data, rows } = props;
    return (
        <TotalVisitsWithShareWrapper>
            <Visits>{dynamicFilterFilter()(data[rows[0].field], rows[0].format)}</Visits>
            <ShareCellWrapper>
                <Share>{dynamicFilterFilter()(data[rows[1].field], rows[1].format)}</Share>
                {i18nFilter()("search.overview.total.visits.share.text", {
                    device: widget.webSource,
                })}
            </ShareCellWrapper>
        </TotalVisitsWithShareWrapper>
    );
};
